import React from 'react'
import logo from '../../assets/image/logo.png';
import chessimg from '../../assets/image/chessimg.jpeg';

const TheBeginnerCourse = () => {
    return (


        <div>
            <div id="preloader-active">
                <div className="preloader d-flex align-items-center justify-content-center">
                    <div className="preloader-inner position-relative">
                        <div className="preloader-circle"></div>
                        <div className="preloader-img pere-text">
                            <img src={logo} alt="Loading..." />
                        </div>
                    </div>
                </div>
            </div>

        
            <main>

                <div class="slider-area ">
                    <div
                        className="single-slider hero-overly  d-flex align-items-center"
                        style={{
                            backgroundImage: `url('${chessimg}')`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'top',
                            height: '460px',
                            width: '100%',
                            overflow: 'hidden',
                        }}
                    >
                        <div class="container">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="hero-cap">
                                        <h2>The Beginner Course</h2>
                                        <nav aria-label="breadcrumb">
                                            <ol class="breadcrumb">
                                                <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                                                <li class="breadcrumb-item"><a href="#">Courses</a></li>
                                                <li class="breadcrumb-item"><a href="#">The Beginner Course</a></li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <br />
                <br />
                <div style={{ marginLeft: '100px' }}>
                    <div class="section-tittle mb-80">
                        <span>All that is included in this course - </span>
                        <h2>THE BEGINNER COURSE</h2>
                    </div>
                    <div class="history-tl-container">
                        <ul class="tl">
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Introduction to chess board</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Introduction to chess notations</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Introduction to chess pieces and points</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Introduction to chess movements and captures</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Introduction to checks</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Techniques how to defend from checks</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Castling</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Pawn Promotion</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">En Passant</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Checkmates</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Stalemates</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title"> Basic Checkmate Positions </div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Checkmate in 1 move(via puzzles)</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Occupying the centre</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Development of Pieces</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">King Safety via castling</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Rook to Rook Connection</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Knight Fork</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Double Attack</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Skewer</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Pin</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Discovered checks and attacks</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Destroying the defender</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Basic King, Rook, Queen Checkmates</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Square Rule</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Back Rank</div>

                            </li>


                        </ul>

                    </div>
                </div>
            </main>

          
            <div id="back-top" style={{ textAlign: 'center' }}>
                <a title="Go to Top" href="#" style={{ display: 'inline-block' }}>
                    <i className="fas fa-level-up-alt"></i>
                </a>
            </div>
        </div>

    )
}

export default TheBeginnerCourse